import React from 'react';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import startOfWeek from 'date-fns/startOfWeek';

import './calendar.css';

const daysInMonth = date => {
	let d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	return d.getDate();
};

export const TaskCalendar = ({ moveMonth, content, locale, dayLength }) => {
	const today = new Date();

	const [month, setMonth] = React.useState(today.getMonth());
	const [year, setYear] = React.useState(today.getFullYear());

	const fireMoveMonth = i => {
		let tempMonth = month + i;
		let tempYear = year;
		if (tempMonth < 0) {
			tempMonth = 11;
			tempYear--;
		}
		if (tempMonth > 11) {
			tempMonth = 0;
			tempYear++;
		}

		setMonth(tempMonth);
		setYear(tempYear);

		moveMonth && moveMonth(tempMonth, tempYear);
	};

	const isWeekend = date => {
		const day = date.getDay();
		return day === 0 || day === 6;
	};

	const displayDates = date => {
		const daysCount = daysInMonth(date);
		const initialDay = date.getDay();
		const today = new Date();

		const weekdays = new Array(7);

		const dayName = d => d.toLocaleDateString(locale || navigator.language || 'en', { weekday: dayLength || 'long' });

		const sunday = startOfWeek(new Date());
		weekdays[0] = dayName(sunday);
		weekdays[1] = dayName(addDays(sunday, 1));
		weekdays[2] = dayName(addDays(sunday, 2));
		weekdays[3] = dayName(addDays(sunday, 3));
		weekdays[4] = dayName(addDays(sunday, 4));
		weekdays[5] = dayName(addDays(sunday, 5));
		weekdays[6] = dayName(addDays(sunday, 6));

		const headers = weekdays.map((x, i) => {
			return (
				<div key={i} className="date header">
					<span className="hidden-xs hidden-sm">{x}</span>
					<span className="hidden visible-xs visible-sm">{x.substr(0, 3)}</span>
				</div>
			);
		});

		const pre = Array.from(Array(initialDay)).map((x, i) => {
			return <div key={`pre${i}`} className="date date-pre" />;
		});

		const dates = Array.from(Array(daysCount)).map((x, i) => {
			const date = new Date(year, month, i + 1);
			let className = isWeekend(date) ? 'date weekend' : 'date';
			if (date.toDateString() === today.toDateString()) className += ' today';
			return (
				<div key={`dates${i}`} className={className}>
					<label>{i + 1}</label>
					{content && <div>{content(date)}</div>}
				</div>
			);
		});

		const postCount = 7 - ((initialDay + daysCount) % 7);
		const post =
			postCount === 7
				? null
				: Array.from(Array(postCount)).map((x, i) => {
						return <div key={`post${i}`} className="date date-post" />;
					});

		return [headers, pre, dates, post];
	};

	const date = new Date(year, month, 1);

	return (
		<div className="calendar">
			<div className="header">
				<button onClick={() => fireMoveMonth(-1)} className="btn btn-sm btn-primary">
					<i className="fa fa-arrow-left" />
				</button>
				<div>{format(date, 'MMMM yyyy')}</div>
				<button onClick={() => fireMoveMonth(1)} className="btn btn-sm btn-primary">
					<i className="fa fa-arrow-right" />
				</button>
			</div>
			<div className="dates">{displayDates(date)}</div>
		</div>
	);
};

export default TaskCalendar;
